// UTM tracking for job application attribution.
//
// Flow: email/social links include UTM query params (utm_source, utm_medium, utm_campaign).
// When the candidate lands on the sign-in page or candidate app, captureUtmParams() reads
// these from the URL and stores them in sessionStorage (survives page navigation but not
// new browser sessions). When the candidate submits an application, getUtmParams() retrieves
// the stored values so they're sent with the POST request and saved on the JobApplication.
// This lets us track where each application originated: email, social, platform, etc.

const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];
const STORAGE_PREFIX = "sq_";

export const captureUtmParams = () => {
  const params = new URLSearchParams(window.location.search);
  const hasUtm = UTM_KEYS.some((key) => params.get(key));
  if (!hasUtm) return;

  UTM_KEYS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      sessionStorage.setItem(`${STORAGE_PREFIX}${key}`, value);
    }
  });
};

export const getUtmParams = () => {
  const result = {};
  UTM_KEYS.forEach((key) => {
    const value = sessionStorage.getItem(`${STORAGE_PREFIX}${key}`);
    if (value) result[key] = value;
  });
  return result;
};

export const clearUtmParams = () => {
  UTM_KEYS.forEach((key) => {
    sessionStorage.removeItem(`${STORAGE_PREFIX}${key}`);
  });
};
